import { CurrentSort } from '@e3dc-react/shell/Elements/Table'
import { TariffTableData } from '../models/tariffs-model'

/**
 * Util function to get sort order for tariffs base on condition:
 * Initial state of sort is undefined
 * Since we are keep user preferences on sort change, first we are checking if sort is already changed and set that value as initial
 * If not, we are checking if dynamic electricity is ON and we set sort by tariff category in ascending(DYNAMIC first)
 * If both conditions are false, we set sort by tariff name ascending as default
 */
export const getInitialTariffSort = (sort: CurrentSort<TariffTableData> | undefined, isDynamicActive: boolean): CurrentSort<TariffTableData> => {
  if (sort) {
    return {
      name: sort.name,
      direction: sort.direction,
    }
  }

  if (isDynamicActive) {
    return {
      name: 'tariffCategory',
      direction: 'asc',
    }
  }

  return {
    name: 'tariffName',
    direction: 'asc',
  }
}
